import PayPal2 from './PayPal2'
export default PayPal2
